<template>
  <div :class="clsx('faq-wrapper', { 'animations-disabled': !animationEnabled })">
    <IntersectionObserver
      class="faq-intersector"
      :animation-enabled="animationEnabled"
      :once="true"
      once-class="faq-intersector--visible"
      :threshold="0.2"
    >
      <div class="faq__background-elements">
        <div class="faq__header"></div>
        <BackgroundCirclesTop class="faq__background-circles-top" />
        <BackgroundCirclesBottom class="faq__background-circles-bottom" />
        <Advantage class="faq__advantage faq__advantage--key"><KeyImage /></Advantage>
        <Advantage class="faq__advantage faq__advantage--puzzle-piece"><PuzzlePieceImage /></Advantage>
        <Advantage class="faq__advantage faq__advantage--student"><StudentImage /></Advantage>
        <Advantage class="faq__advantage faq__advantage--laptop"><LaptopImage /></Advantage>
        <Advantage class="faq__advantage faq__advantage--bell"><BellImage /></Advantage>
        <Advantage class="faq__advantage faq__advantage--gear"><GearImage /></Advantage>
        <BackgroundGradientTop class="faq__background-gradient-top" />
        <BackgroundGradientBottom class="faq__background-gradient-bottom" />
      </div>
      <div class="faq__title-block">
        <h2 class="faq__title" v-html="replaceFancyText(getTitleBlock('promo', 'faq', 'title'), 'faq')"></h2>
        <p class="faq__subtitle" v-html="getTitleBlock('promo', 'faq', 'description')"></p>
      </div>
      <div class="faq__start-block">
        <div class="faq__start-block__start-now">
          <div class="faq__start-block__start-now__wrapper">
            <VioletFancyButton :route="{ name: 'registration' }" class="faq__start-block__start-now__button">
              Готовий розібратись сам
            </VioletFancyButton>
          </div>
          <p class="faq__start-block__start-now__description">Зареєструйся — і почни<br /> працювати з CRM вже зараз.</p>
        </div>
        <div class="faq__start-block__presentation-subscribe">
          <div class="faq__start-block__presentation-subscribe__wrapper">
            <OrangeFancyButton hash="#subscribe" class="faq__start-block__presentation-subscribe__button">
              Спочатку побачити все в дії
            </OrangeFancyButton>
          </div>
          <p class="faq__start-block__presentation-subscribe__description">Залиши контакт — ми зв’яжемось і<br /> покажемо, як працює Ukasko.</p>
        </div>
      </div>
      <div class="faq__accordion">
        <Accordion v-for="(item, index) in faqItems" :key="index" class="faq__item">
          <template v-slot:title>
            <p class="faq__accordion-title" v-html="item.title"></p>
          </template>
          <p class="faq__accordion-text" v-html="item.text"></p>
        </Accordion>
      </div>
      <div class="faq__footer"></div>
    </IntersectionObserver>
  </div>
</template>

<script>
import clsx from 'clsx';
import BackgroundGradientBottom from './background-gradient-bottom';
import BackgroundGradientTop from './background-gradient-top';
import { textBlock } from '@/entities/text-block';
import { ukaskoFancyText } from '@/features/promo';
import { Accordion } from '@/shared/ui/accordion';
import { OrangeFancyButton, VioletFancyButton } from '@/shared/ui/form';
import { IntersectionObserver } from '@/shared/ui/intersection-observer';
import { Advantage, BackgroundCirclesBottom, BackgroundCirclesTop } from '@/shared/ui/promo';
import { BellImage, GearImage, KeyImage, LaptopImage, PuzzlePieceImage, StudentImage } from '@/shared/ui/promo';

export default {
  props: {
    animationEnabled: {
      type: Boolean,
      default: true,
    },
  },
  mixins: [ textBlock, ukaskoFancyText ],
  components: {
    BackgroundCirclesTop, Advantage, OrangeFancyButton, VioletFancyButton, Accordion, BackgroundCirclesBottom,
    BackgroundGradientBottom, BackgroundGradientTop, KeyImage, BellImage, PuzzlePieceImage, GearImage, LaptopImage,
    StudentImage, IntersectionObserver
  },
  computed: {
    faqItems() {
      const textBlock = this.getListBlock('promo', 'faq-list');
      return textBlock.map((item) => {
        return {
          title: item.key,
          text: item.value,
        };
      });
    },
  },
  methods: { clsx },
};
</script>

<style lang="scss" scoped>
.faq-intersector {
  position: relative;
  background-color: #CADDFC;
  opacity: 1;
  overflow: hidden;
}

.faq__header {
  position: relative;
  display: block;
  height: 52px;
  width: 100%;
  background-color: #FCFDFF;
  border-radius: 0 0 52px 52px;
  margin-bottom: 95px;
  z-index: 1;
}

.faq__footer {
  position: relative;
  display: block;
  height: 32px;
  width: 100%;
  background-color: #FCFDFF;
  border-radius: 32px 32px 0 0;
  margin-top: 95px;
  z-index: 1;
}

.faq__background-circles-top {
  position: absolute;
  top: -291px;
  right: 0;
}

.faq__background-circles-bottom {
  position: absolute;
  left: 0;
  bottom: -300px;
}

.faq__background-gradient-top {
  position: absolute;
  top: -400px;
  left: 50%;
  transform: translateX(-50%);
}

.faq__background-gradient-bottom {
  position: absolute;
  left: 50%;
  bottom: -550px;
  transform: translateX(-50%);
}

::v-deep .faq__fancy-text {
  background: linear-gradient(90deg, #4555CC 0%, #D75693 50%, #EB893C 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  color: transparent;
}

.faq__advantage {
  position: absolute;

  &--key {
    top: 82px;
    left: 215px;
    opacity: 0.2;
  }

  &--puzzle-piece {
    top: 180px;
    left: 90px;
    opacity: 0.2;
  }

  &--bell {
    top: 175px;
    left: 275px;
    opacity: 0.6;
  }

  &--gear {
    top: 325px;
    left: 225px;
    opacity: 0.6;
  }

  &--laptop {
    top: 400px;
    left: 105px;
    opacity: 0.3;
  }

  &--student {
    top: 425px;
    left: 315px;
    opacity: 0.2;
  }
}

.faq__title-block {
  margin-bottom: 45px;
  position: relative;
  z-index: 1;
}

.faq {
  &__accordion {
    max-width: 660px;
    margin: 0 auto;

    @media (max-width: 720px) {
      margin-left: 16px;
      margin-right: 16px;
    }
  }

  &__item {
    position: relative;
    z-index: 1;
  }

  &__accordion-title {
    font-family: 'Inter', sans-serif;
  }

  &__accordion-text {
    font-family: 'Inter', sans-serif;
  }

  &__title {
    font-family: "IBM Plex Sans", sans-serif;
    font-size: 72px;
    font-weight: 500;
    color: #313437;
    text-align: center;
    margin-bottom: 5px;
    transform: translateY(100%);
    opacity: 0;
    animation: slideup-text-animation 1s linear forwards;
    animation-play-state: paused;

    @media (max-width: 1050px) {
      font-size: 64px;
      margin-bottom: 16px;
    }

    @media (max-width: 800px) {
      font-size: 56px;
    }

    @media (max-width: 600px) {
      font-size: 44px;
    }

    @media (max-width: 500px) {
      font-size: 36px;
    }
  }

  &__subtitle {
    font-family: 'Inter', sans-serif;
    font-size: 18px;
    font-weight: 400;
    color: #494E53;
    text-align: center;
    transform: translateY(100%);
    opacity: 0;
    animation: slideup-text-animation 0.5s linear forwards;
    animation-delay: 1s;
    animation-play-state: paused;

    @media (max-width: 600px) {
      margin: 0 16px;
    }
  }
}

.faq__start-block {
  position: relative;
  display: flex;
  justify-content: center;
  padding-bottom: 95px;
  z-index: 1;

  @media (max-width: 600px) {
    flex-direction: column;
  }

  &__start-now {
    margin-right: 32px;

    @media (max-width: 600px) {
      margin: 0 auto;
    }

    &__wrapper {
      height: 56px;
      margin-bottom: 8px;
      overflow: hidden;
    }

    &__button {
      transform: translateY(100%) scale(0.7);
      animation: start-block-animation 0.5s linear forwards;
      animation-delay: 1.5s;
      animation-play-state: paused;

      @media (max-width: 600px) {
        width: 280px;
      }
    }

    &__description {
      font-family: 'Inter', sans-serif;
      font-size: 16px;
      font-weight: 400;
      color: #3DABDE;
      text-align: center;
      transform: translateY(100%);
      opacity: 0;
      animation: slideup-text-animation 0.5s linear forwards;
      animation-delay: 1.5s;
      animation-play-state: paused;
    }
  }

  &__presentation-subscribe {
    @media (max-width: 600px) {
      margin: 0 auto;
    }

    &__wrapper {
      height: 56px;
      margin-bottom: 8px;
      overflow: hidden;
    }

    &__button {
      transform: translateY(100%) scale(0.7);
      animation: start-block-animation 0.5s linear forwards;
      animation-delay: 1.5s;
      animation-play-state: paused;

      @media (max-width: 600px) {
        width: 280px;
      }
    }

    &__description {
      font-family: 'Inter', sans-serif;
      font-size: 16px;
      font-weight: 400;
      color: #EB883B;
      text-align: center;
      transform: translateY(100%);
      opacity: 0;
      animation: slideup-text-animation 0.5s linear forwards;
      animation-delay: 1.5s;
      animation-play-state: paused;
    }
  }
}

.faq-intersector {
  &--visible {
    .faq__title, .faq__subtitle, .faq__start-block__start-now__description,
    .faq__start-block__presentation-subscribe__description,
    .faq__start-block__start-now__button,
    .faq__start-block__presentation-subscribe__button {
      animation-play-state: running;
    }
  }
}

.animations-disabled,
.animations-disabled * {
  animation: none !important;
  animation-duration: 0s !important;
  animation-delay: 0s !important;
  transition: none !important;
}

.animations-disabled {
  .faq {
    &__title, &__subtitle {
      clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
      transform: translateY(0);
      opacity: 1;
    }
  }

  .faq__start-block {
    &__start-now {
      &__button {
        transform: translateY(0) scale(1);
      }

      &__description {
        clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
        transform: translateY(0);
        opacity: 1;
      }
    }

    &__presentation-subscribe {
      &__button {
        transform: translateY(0) scale(1);
      }

      &__description {
        clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
        transform: translateY(0);
        opacity: 1;
      }
    }
  }
}

@keyframes slideup-text-animation {
  0% {
    opacity: 1;
    clip-path: polygon(0 0, 100% 0, 100% 0%, 0 0%);
    transform: translateY(100%);
  }
  20% {
    opacity: 1;
    clip-path: polygon(0 0, 100% 0, 100% 20%, 0 20%);
    transform: translateY(80%);
  }
  40% {
    opacity: 1;
    clip-path: polygon(0 0, 100% 0, 100% 40%, 0 40%);
    transform: translateY(60%);
  }
  60% {
    opacity: 1;
    clip-path: polygon(0 0, 100% 0, 100% 60%, 0 60%);
    transform: translateY(40%);
  }
  80% {
    opacity: 1;
    clip-path: polygon(0 0, 100% 0, 100% 80%, 0 80%);
    transform: translateY(20%);
  }
  100% {
    opacity: 1;
    clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
    transform: translateY(0);
  }
}

@keyframes start-block-animation {
  from {
    transform: translateY(100%) scale(0.7);
  }
  to {
    transform: translateY(0) scale(1);
  }
}
</style>
